import React, {useMemo, useState } from 'react';
import {
	Card,
    Dropdown,
    InputField
} from '@bosch/bt-ui';

import './NetworkConfigFields.css';
import withErrorHandler from '../../../components/ErrorHandler';

const NetworkConfigFields = (props) => {
    const {
        netWorkFormValues: networkFormValues,
        subnetFormValues,
        updateNetworkFormValues,
        updateSubnetFormValues,
        mode,
    } = props;
    console.log(props);
    const cidrRange = [];
    var tier3OnCreation = (networkFormValues.networkModel === 'TIER3_STANDARD' && mode !== 'update');

    for (var i = 0 ; i <= 32 ; i++) {
        cidrRange.push({
               label: i,
               value: i,
            });
    }
    const options = [
        {
           label: 'Tier3 Standard',
           value: 'TIER3_STANDARD',
        },
        {
           label: 'Tier2 Standard',
           value: 'TIER2_STANDARD'
        },
        {
            label: 'Tier2 Standard No NAT',
            value: 'TIER2_STANDARD_NO_NAT'
         },
         {
            label: 'Tier2 Standard Do Internet',
            value: 'TIER2_STANDARD_DO_INTERNET'
         }
     ];
     const [value,setValue]=useState('Small/Medium Companies that connect to devices through an on-demand VPN Client, and with device originating traffic exiting to the Internet.');
     const [StartIpRange,setsIpValue]=useState('');
     const [EndIpRange,seteIpValue]=useState('');
     const [isIpVaild,seteIpVaild]=useState(false);
     if(networkFormValues.networkModel === '') {networkFormValues.networkModel = 'TIER3_STANDARD'};
     const description = useMemo(
		() => {
            if (!networkFormValues)
                return null;
            if(networkFormValues.networkModel === 'TIER3_STANDARD')
            {
                setValue('Small/Medium Companies that connect to devices through an on-demand VPN Client, and with device originating traffic exiting to the Internet.')
            }
            else if(networkFormValues.networkModel === 'TIER2_STANDARD')
            {
                setValue('Medium/Large Companies that directly connect to devices through a dedicated & persistent VPN tunnel, with device originating traffic routing back through same tunnel (2-way). Devices are represented by custom NAT IP addresses.')
            }
            else if(networkFormValues.networkModel === 'TIER2_STANDARD_NO_NAT')
            {
                setValue('Same as Tier2 Standard, but with no NAT IP address translation (rarely used).')
            }
            else if(networkFormValues.networkModel === 'TIER2_STANDARD_DO_INTERNET')
            {
                setValue('Same as Tier2 Standard, but device originating traffic exits to the Internet and does not route down VPN tunnel (1-way). NAT IPs are used to reach device only.')
            };   
		},
		[networkFormValues]
	);
    const [title, setTitle] = useState('')
    const isVaildIP = useMemo(() => {
        if (!subnetFormValues)
            return null;
        console.log(subnetFormValues);
        checkIPaddress(subnetFormValues)},
         [subnetFormValues]
         );
    
    function ValidateIPaddress(ipaddress) 
    {
        if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress))
        {
            return (true)
        }
        return (false)
    }

    function checkIPaddress(object) {
        console.log('Start checkIPaddress');
        if(ValidateIPaddress(object.domainIp) && object.cidr !== '')
        {
            //console.log(object.domainIp+"/"+object.cidr);
            const IPCIDR = require('ip-cidr');
            const cidr = new IPCIDR(object.domainIp+'/'+object.cidr);
            console.log(cidr);
            setsIpValue(cidr.start());
            seteIpValue(cidr.end());
            seteIpVaild(true)
            return;
        }
        else
        {
            seteIpVaild(false)
            return;
        }
    }

    return (
		<Card
			htmlAttributes={{
				id: 'networkConfig',
				className: 'firmware-overview-section'
			}}
		>
			<div className="caption font-large">Network Model Settings</div>
            <h4 style={{'marginTop': '0em'}}>Description: {value}</h4>
            <div className="networkconfig-input-field">
                <Dropdown
                    fieldName="networkModel"
                    label="Network Model"
                    htmlAttributes={{
                        onChange: mode === 'update' ? null : updateNetworkFormValues,
                        value: networkFormValues.networkModel,
                        disabled: mode === 'update' ? true : false
                    }}
                    options={options}
                />                
                <InputField
                    inputType="text"
                    fieldName="domainIp"
                    label="Start of IP Range:"
                    htmlAttributes={{
                        onChange: updateSubnetFormValues,
                        value: tier3OnCreation === true ? '' : subnetFormValues.domainIp,
                        disabled: networkFormValues.networkModel === 'TIER3_STANDARD' ? true : false
                    }}
                />
                <Dropdown
                    fieldName="cidr"
                    label="IP Network Prefix"
                    htmlAttributes={{
                        onChange: updateSubnetFormValues,
                        value: tier3OnCreation === true ? 0 : subnetFormValues.cidr,
                        disabled: networkFormValues.networkModel === 'TIER3_STANDARD' ? true : false
                    }}
                    options={cidrRange}
                />
                {isIpVaild === false ? null : <h4 style={{'marginTop': '0em', 'marginBottom': '0em'}}> Subnet IP Range from : {StartIpRange} to : {EndIpRange}</h4>}
                <InputField
                    inputType="text"
                    fieldName="vpnEndpoint"
                    label="VPN Endpoint"
                    htmlAttributes={{
                        onChange: updateNetworkFormValues,
                        value: networkFormValues.networkModel === 'TIER3_STANDARD' ? networkFormValues.vpnEndpoint : '',
                        disabled: tier3OnCreation === false ? true : false
                    
                    }}
                />
            </div>
        </Card>
    );
};

export default withErrorHandler(React.memo(NetworkConfigFields));